exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-skip[data-v-9c24cd74],\n.action-complete[data-v-9c24cd74] {\n  color: #fff !important;\n}\n#sidebar .flow label[data-v-9c24cd74] {\n  position: relative;\n  width: 100%;\n}\n.ico-task-attention[data-v-9c24cd74] {\n  position: absolute;\n  top: 0.1em;\n  right: -1em;\n  z-index: 1;\n  border-radius: 2px;\n}", ""]);

// exports
